import { render, staticRenderFns } from "./EditLinkWithDropdownMenu.vue?vue&type=template&id=70e7bb37&scoped=true&"
import script from "./EditLinkWithDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./EditLinkWithDropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./EditLinkWithDropdownMenu.vue?vue&type=style&index=0&id=70e7bb37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7bb37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
